import { ColorHelper } from '@sydle/ui-design-system';
import tinycolor from 'tinycolor2';

const Color = tinycolor;

export class SDColorHelper extends ColorHelper {
  /**
   * Generate color variations
   * @param {string} colorValue
   */
  static getColorVariations(colorValue: string): { name: string; value: string }[] {
    const color = Color(colorValue);
    const contrast = this.getContrastColor(colorValue);
    return [
      {
        name: 'contrast',
        value: contrast,
      },
      {
        name: 'hover',
        value: Color.mix(color, contrast, 15).toHexString(),
      },
      {
        name: 'active',
        value: Color.mix(color, contrast, 20).toHexString(),
      },
      {
        name: 'light',
        value: Color.mix(color, contrast, 5).toHexString(),
      },
    ];
  }
}
